export default __webpack_public_path__ + "static/media/img-0472-bulgaria-full-face.ef72ecbc.png";